import { InfoCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Col, message, Row, Spin, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, Form, FormItem, InputItem, InputNumberItem, SelectItem, SwitchItem } from "../../../../Components/Items";
import SelectInsumosServicioBiwoItem from "../../../../Components/SelectInsumosServicioBiwoItem";
import { postCobro } from "./cobroBiwoTextos";

const CAMPOS_REMISION = [
    { name: "proyectoId", label: "Proyecto", catalogo: "proyectos" },
    { name: "precioId", label: "Lista de precios", catalogo: "precios", extra: "Solo se registra en la remisión; el precio unitario es el que calcula el cobro (sin IVA)." },
    { name: "formaDePagoId", label: "Forma de pago", catalogo: "formasDePago" },
    { name: "usoDeCfdiId", label: "Uso de CFDI", catalogo: "usosCfdi" },
    { name: "vendedorId", label: "Vendedor", catalogo: "vendedores" },
    { name: "tipoClienteId", label: "Tipo de cliente", catalogo: "tiposDeCliente", extra: "Para los clientes que se den de alta solos al generar la remisión." },
];

const estiloBarra = {
    backgroundColor: "white",
    padding: "12px 20px",
    border: "1px solid rgb(235, 237, 240)",
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
};

const Seccion = ({ titulo, ayuda, children }) => (
    <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, fontWeight: 600, color: "#1a3a4a", paddingBottom: 10, marginBottom: 12, borderBottom: "1px solid #f0f0f0" }}>
            {titulo}
            {ayuda && (
                <Tooltip title={ayuda}>
                    <InfoCircleOutlined style={{ color: "#8c8c8c" }} />
                </Tooltip>
            )}
        </div>
        {children}
    </div>
);

class ConfiguracionCobro extends Component {
    formRef = React.createRef();
    state = { loading: true, datos: null, version: 0, empresas: [], catalogos: null };

    componentDidMount() {
        this.consultar();
        postCobro(axios, "selectEmpresasEmisoras", {}, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ empresas: data.data });
        });
    }

    consultar = () => {
        this.setState({ loading: true });
        postCobro(axios, "selectConfiguracionCobroBiwo", {}, this.props.headersToken).then((data) => {
            this.setState((s) => ({ loading: false, datos: data.success === 2 ? data.data : {}, version: s.version + 1 }));
            if (data.success === 2 && data.data.empresaEmisoraId) {
                postCobro(axios, "selectCatalogosEmisora", {}, this.props.headersToken).then((cat) => {
                    if (cat.success === 2) this.setState({ catalogos: cat.data });
                });
            }
        });
    };

    guardar = () => {
        this.formRef.current.validateFields().then((values) => {
            this.setState({ loading: true });
            postCobro(axios, "guardarConfiguracionCobroBiwo", values, this.props.headersToken).then((data) => {
                if (data.success === 2) {
                    message.success(data.message);
                    this.consultar();
                } else {
                    this.setState({ loading: false });
                    message.error(data.message || "No se pudo guardar");
                }
            });
        });
    };

    render() {
        const { datos, catalogos } = this.state;
        return (
            <div>
                <div style={estiloBarra}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: "#1a3a4a" }}>Configuración de cobro</span>
                    <ButtonItem botonAncho icon={<SaveOutlined />} disabled={!datos} onClick={this.guardar}>Guardar</ButtonItem>
                </div>
                <Spin spinning={this.state.loading}>
                    {datos && (
                        <Form
                            key={this.state.version}
                            ref={this.formRef}
                            layout
                            initialValues={{
                                empresaEmisoraId: datos.empresaEmisoraId || undefined,
                                insumoFacturaUnicaId: datos.insumoFacturaUnicaId || undefined,
                                insumoDesarrolloId: datos.insumoDesarrolloId || undefined,
                                precioHoraDesarrollo: datos.precioHoraDesarrollo || 0,
                                recordatorios: datos.recordatorios,
                                ...Object.fromEntries(CAMPOS_REMISION.map((c) => [c.name, datos[c.name] || undefined])),
                            }}
                        >
                            <Seccion titulo="Empresa emisora">
                                <Row gutter={[16, 4]}>
                                    <Col xs={24} lg={12}>
                                        <FormItem margin label="Empresa emisora" name="empresaEmisoraId" required tooltip="Si cambias de empresa emisora se limpian los demás datos.">
                                            <SelectItem
                                                width="100%"
                                                placeholder="Empresa que emite las remisiones"
                                                showSearch
                                                optionFilterProp="label"
                                                options={this.state.empresas.map((e) => ({ value: e._id, label: e.rfc ? `${e.nombre} - ${e.rfc}` : e.nombre }))}
                                            />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Seccion>
                            {datos.empresaEmisoraId && (
                                <>
                                    <Seccion titulo="Insumos">
                                        <Row gutter={[16, 4]}>
                                            <Col xs={24} lg={12}>
                                                <FormItem
                                                    margin
                                                    label="Insumo general"
                                                    name="insumoFacturaUnicaId"
                                                    required
                                                    tooltip="Concepto único de la factura y el que se usa en partidas sin insumo asignado."
                                                >
                                                    <SelectInsumosServicioBiwoItem width="100%" />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Insumo de desarrollo" name="insumoDesarrolloId" tooltip="Desarrollo de módulos personalizados en el cotizador de plan BIWO.">
                                                    <SelectInsumosServicioBiwoItem width="100%" />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Precio por hora de desarrollo" name="precioHoraDesarrollo" tooltip="Sin IVA">
                                                    <InputNumberItem dinero min={0} />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Seccion>
                                    <Seccion
                                        titulo="Datos de la remisión"
                                        ayuda="Si el master tiene ligado un cliente de la empresa emisora, la remisión respeta su forma de pago, uso de CFDI, lista de precios y vendedor."
                                    >
                                        <Row gutter={[16, 4]}>
                                            {CAMPOS_REMISION.map((c) => (
                                                <Col key={c.name} xs={24} lg={12}>
                                                    <FormItem margin label={c.label} name={c.name} required tooltip={c.extra}>
                                                        <SelectItem width="100%" showSearch optionFilterProp="label" placeholder={c.label} options={catalogos?.[c.catalogo] || []} />
                                                    </FormItem>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Seccion>
                                    <Seccion titulo="Recordatorios de cobranza">
                                        <Row gutter={[16, 4]}>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Enviar recordatorios" name={["recordatorios", "activo"]} valuePropName="checked">
                                                    <SwitchItem />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Copia a" name={["recordatorios", "correoCopia"]} tooltip="Correos de BIWO que reciben copia, separados por coma.">
                                                    <InputItem placeholder="cobranza@biwo.mx" />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Avisar del próximo cobro" name={["recordatorios", "diasAvisoPrevio"]} tooltip="Días antes de que se genere la remisión. 0 = no avisar.">
                                                    <InputNumberItem min={0} max={60} precision={0} />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Primer recordatorio de vencida" name={["recordatorios", "diasGracia"]} tooltip="Días después del vencimiento.">
                                                    <InputNumberItem min={0} max={90} precision={0} />
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <FormItem margin label="Repetir cada" name={["recordatorios", "diasEntreVencidos"]} tooltip="Días entre recordatorios mientras siga vencida.">
                                                    <InputNumberItem min={1} max={90} precision={0} />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Seccion>
                                </>
                            )}
                        </Form>
                    )}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(ConfiguracionCobro);
